import { computed, ref } from 'vue'

import type { CanvasSelectionType } from '@canvas-selector/appTypes'
import type { Canvas } from '@openapi'

const activeSelectionType = ref<CanvasSelectionType | null>(null)
const data = ref<{
  canvases?: Canvas[]
  canvasTemplates?: Canvas[]
  sections?: Canvas[]
  sectionTemplates?: Canvas[]
} | null>(null)
const selectedItems = ref<Canvas[]>([])
const selectedCanvases = computed(() => selectedItems.value.filter((i) => !i.is_section && !i.is_template))
const selectedCanvasTemplates = computed(() => selectedItems.value.filter((i) => i.is_template && !i.is_section))
const selectedSections = computed(() => selectedItems.value.filter((i) => !i.is_template && i.is_section))
const selectedSectionTemplates = computed(() => selectedItems.value.filter((i) => i.is_section && i.is_template))

function cleanup() {
  activeSelectionType.value = null
  data.value = null
  selectedItems.value = []
}

export default function useApp() {
  return {
    activeSelectionType,
    data,
    selectedItems,
    selectedCanvases,
    selectedCanvasTemplates,
    selectedSections,
    selectedSectionTemplates,
    cleanup,
  }
}
